import { render } from "./TabSelect.vue?vue&type=template&id=e3870400&scoped=true"
import script from "./TabSelect.vue?vue&type=script&lang=js"
export * from "./TabSelect.vue?vue&type=script&lang=js"

import "./TabSelect.vue?vue&type=style&index=0&id=e3870400&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3870400"]])

export default __exports__